import store from "@/store";
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/firestore";

const appData = {
  dev: {
    apiKey: "AIzaSyAN7MJ0IDTN6-N37ca0nEBEm6a3m-J7yT4",
    authDomain: "heartbeatfamdev.firebaseapp.com",
    projectId: "heartbeatfamdev",
    storageBucket: "heartbeatfamdev.appspot.com",
    messagingSenderId: "19335738204",
    appId: "1:19335738204:web:8be07d94d8f80cf5f30799",
    measurementId: "G-BTMY5MGJKK"
  },
  prod: {
    apiKey: "AIzaSyDlC_HLIOvFOhZX4wKEQNh78i6bTw1Nl-M",
    authDomain: "ponyengineinc.firebaseapp.com",
    projectId: "ponyengineinc",
    storageBucket: "ponyengineinc.appspot.com",
    messagingSenderId: "815841522627",
    appId: "1:815841522627:web:5e579a846d13fd94f98376",
    measurementId: "G-8TJH7FYE8W"
  }
};
let firebaseApp = firebase.initializeApp(appData.prod);

firebase.analytics();

export default {
  install: (Vue, options) => {
    const auth = firebaseApp.auth();
    auth.onAuthStateChanged(user => {
      store.commit("user/UPDATE_USER", { user });
      if (user) {
        store.dispatch("user/getUserDeviceRegistrationToken");
      }
    });
  }
};
